// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__XUnoM","content":"RecentSearches_content__DuPqa"};